import styled, { css } from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';

export const Apps = styled.div`
  ${({ theme }) => css`
    margin: auto;
    display: flex;

    & > a {
      max-width: 130px;
      margin: ${theme.spacing.unit}px;
      min-height: 42px;
      ${media.md`
        max-width: 200px;
        margin: 0;
      `}
    }

    & > a > img {
      height: auto;
    }

    & > * + * {
      margin-left: 16px !important;
    }
  `}
`;
